import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Checkbox from "sushiweb/InputTypes/Checkbox";
import CrossCircle from "sushiweb/Icons/all/CrossCircle";
import ChevronDown from "sushiweb/Icons/all/ChevronDown";
import Button from "sushiweb/Button";
import { FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import Spinner from "sushiweb/Spinner/Spinner";
import { getPath } from "../../../utils";

const YOffset = 170;

const PaginatedReactDropdown = (props) => {
  const {
    placeholder,
    options,
    labelKey,
    valueKey,
    marginTop,
    marginBottom,
    labelWidth,
    showCross,
    keyToChange,
    disabled,
    isOptionDisabled,
    handleSelect,
    handleChange,
    showPagination,
    nextPage,
    handleNextPage,
    value,
    noLabelSelect,
    extraParams = [],
    extraParamsPagination = [],
    id,
    className,
    width,
    optionsBoxId,
    key,
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [inputHeight, setInputHeight] = useState(0);
  const [currEleCoord, setCurrEleCoord] = useState({
    X: "",
    Y: "",
    width: "",
  });
  const [optionsList, setOptionsList] = useState([]);
  let inputDiv = document.getElementById(id);
  let optionsBoxDiv = document.getElementById(optionsBoxId);
  let target = document.getElementById("spinLoader");

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    const observer = new IntersectionObserver(async function (
      entries,
      observer
    ) {
      if (entries[0].isIntersecting && typeof handleNextPage === "function") {
        const updatedList = await handleNextPage(optionsList, [
          ...extraParamsPagination,
        ]);
        if (updatedList.length > 0) {
          setOptionsList(updatedList);
        }
      }
    },
    observerOptions);
    const target = document.getElementById("spinLoader");
    if (target) {
      observer.observe(target);
    }
    return () => observer.disconnect(target);
  }, [optionsList]);

  const handleClick = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleCheckboxSelect = (value) => {
    const index = selectedValues.indexOf(value);
    if (index === -1) {
      setSelectedValues([...selectedValues, value]);
    } else {
      setSelectedValues(selectedValues.filter((val) => val !== value));
    }
  };

  const handleConfirm = () => {
    const concatenatedValue = selectedValues.join(", ");
    // Set the selected label
    setSelectedLabel(concatenatedValue);
    handleChange(keyToChange, concatenatedValue, [...extraParams]);
    setIsOpen(false);
  };

  const handleCrossClick = () => {
    setSelectedValues([]);
    setSelectedLabel("");
    setIsOpen(false);
    handleChange(keyToChange, "", [...extraParams]);
  };

  useEffect(() => {
    if (inputDiv) {
      const coords = inputDiv.getBoundingClientRect();
      const newCoord = { ...currEleCoord };
      newCoord["X"] = coords.x;
      newCoord["Y"] = coords.y + coords.height + YOffset;
      newCoord["width"] = coords.width;
      setCurrEleCoord(newCoord);
      const height = inputDiv.offsetHeight;
      setInputHeight(height);
    }
  }, [inputDiv, id]);

  useEffect(() => {
    if (value) {
      const values = value.split(", ");
      setSelectedLabel(values.join(", "));
      setSelectedValues(values);
    } else {
      setSelectedLabel("");
      setSelectedValues([]);
    }
  }, [value]);

  useEffect(() => {
    setOptionsList([...options]);
  }, [options.length]);

  useEffect(() => {
    !showPagination && setOptionsList([...options]);
  }, [options, showPagination]);

  return (
    <PaginatedDropdownContainer
      ref={dropdownRef}
      width={width}
      marginTop={marginTop}
      className="pr-10"
    >
      <PaginatedDropdown
        className={`${className} ${
          disabled ? "disable" : "enable"
        } customDropdown`}
        tabIndex="0"
        onBlur={handleClose}
        marginBottom={marginBottom}
        id={id}
        align="flex-start"
        onClick={handleClick}
        key={key}
      >
        <FlexContainer style={{ width: "100%" }} justify="space-between">
          <PlaceholderText
            inputHeight={inputHeight}
            labelWidth={labelWidth}
            className={selectedLabel && "isLabel"}
          >
            {placeholder}
          </PlaceholderText>
          {selectedLabel && <InputText>{selectedLabel}</InputText>}
          <IconHolder>
            {selectedLabel && showCross && (
              <CrossCircle
                onClick={handleCrossClick}
                className="cross"
                color={"#000"}
              />
            )}
            <ChevronDown
              className={`chevron ${isOpen && "open"}`}
              color={"#000"}
            />
          </IconHolder>
        </FlexContainer>
        <OptionsBox
          className={isOpen && "open"}
          id={optionsBoxId || "optionsBox"}
          currCoords={currEleCoord}
          open={isOpen}
          inputHeight={inputHeight}
        >
          {optionsList.length > 0 ? (
            optionsList.map((option, index) => (
              <MenuItem key={index}>
                <Checkbox
                  value="checkbox3"
                  label={
                    typeof option !== "object"
                      ? option
                      : getPath(option, labelKey, "")
                  }
                  checked={selectedValues.includes(
                    typeof option !== "object"
                      ? option
                      : getPath(option, valueKey, "")
                  )}
                  onChange={() =>
                    handleCheckboxSelect(
                      typeof option !== "object"
                        ? option
                        : getPath(option, valueKey, "")
                    )
                  }
                />
              </MenuItem>
            ))
          ) : (
            <NoDataState>No results found</NoDataState>
          )}
          <ButtonContainer>
            <Button btnColor="green" onClick={handleConfirm}>
              Confirm
            </Button>
            <Button btnColor="red" onClick={handleCrossClick}>
              Cancel
            </Button>
          </ButtonContainer>
          <div style={{ height: "10px" }}></div>
          {showPagination && nextPage !== -1 ? (
            <LoaderContainer>
              <Loader id="spinLoader">
                <Spinner size="small" />
              </Loader>
            </LoaderContainer>
          ) : null}
        </OptionsBox>
      </PaginatedDropdown>
    </PaginatedDropdownContainer>
  );
};

PaginatedReactDropdown.defaultProps = {
  placeholder: "Select item",
  options: [],
  labelWidth: "45%",
  showCross: false,
  showPagination: false,
  nextPage: -1,
};

const PaginatedDropdownContainer = styled.div`
  width: ${({ width }) => (width ? width : "100%")};
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : "0px")};
`;

const PaginatedDropdown = styled(FlexContainer)`
  border: 1px solid ${variables.grey300};
  background: ${variables.grey100};
  flex-direction: column;
  border-radius: 8px;
  padding: 14px 18px;
  box-sizing: border-box;
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? marginBottom : "28px"};
  width: 100%;
  cursor: pointer;
  position: relative;

  .chevron {
    transform: rotate(0deg);
    transition: 0.5s all;
    &.open {
      transform: rotate(180deg);
    }
  }
  &.disable {
    pointer-events: none !important;
    opacity: 0.5;
  }
`;

const PlaceholderText = styled.p`
  margin-right: 20px;
  color: ${variables.grey600};
  &.isLabel {
    font-size: 12px !important;
    color: ${variables.grey700};
    transform: translate(-10px, -${(props) => props.inputHeight / 2}px);
    background: ${variables.grey50};
    margin-right: 0px;
    width: ${(props) => (props.labelWidth ? props.labelWidth : "40%")};
    position: absolute;
  }
`;

const InputText = styled.p``;

const IconHolder = styled.div`
  display: flex;
  .cross {
    opacity: 0.5;
    width: 15px;
    height: auto;
    margin-right: 10px;
  }
`;

const OptionsBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  transform: ${(props) =>
    props.open ? `translateY(${props.inputHeight + 2}px)` : "translateY(0px)"};
  transition: 0.5 all;
  width: 100%;
  border: 1px solid ${variables.grey300};
  border-radius: 8px;
  background: #fff;
  min-height: 5rem;
  max-height: 20rem;
  overflow: scroll;
  display: none;

  &.open {
    display: block;
  }
`;

const NoDataState = styled.p`
  text-align: center;
  color: ${variables.grey500};
  margin-top: 30px;
`;

const ButtonContainer = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: center;
  background-color: white;
  padding: 10px 20px; /* Add padding to the left and right */
  margin-top: auto; /* Ensures it sticks to the bottom */
  z-index: 1;
  gap: 10px; /* Add space between the buttons */
`;

const LoaderContainer = styled.div`
  padding: 5px 16px;
`;

const Loader = styled.div``;

const MenuItem = styled.div`
  padding: 10px 16px;
  &:hover {
    background: ${variables.red50};
    color: red;
  }
  &:not(:last-child) {
    border-bottom: 1px solid ${variables.grey200};
  }
`;

export default PaginatedReactDropdown;
